import { render, staticRenderFns } from "./SBoxStemdoerExperience.vue?vue&type=template&id=6b7ab5ee&scoped=true"
import script from "./sBoxStemdoerExperience.ts?vue&type=script&lang=ts&external"
export * from "./sBoxStemdoerExperience.ts?vue&type=script&lang=ts&external"
import style0 from "./SBoxStemdoerExperience.vue?vue&type=style&index=0&id=6b7ab5ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7ab5ee",
  null
  
)

export default component.exports